import styled from 'styled-components';
import ButtonBase from '../base/Base';

const ButtonLiquidPrimary = styled(ButtonBase)`
  background-color: ${props => props.theme.colors.primary};
  width: 100%;
  color: #fff;
  padding: 1.5rem 3rem;
`;

export default ButtonLiquidPrimary;



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/liquid/Primary.js